

var Shopify = Shopify || {};

// Money format handler
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (
            typeof opt == 'undefined'
                ? def
                : opt
        );
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1]
                ? (decimal + parts[1])
                : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
        return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
};
Shopify.progressBarShipping = function () {
    let customerCountry = Shopify.country.toLowerCase();
    let definedCountries = ['at', 'de', 'ch', 'us'];

// Define treshold
    let treshold = parseInt('10000');
    if (!definedCountries.includes(customerCountry)) {
        treshold = parseInt('10500');
    }

// Define currency
    let currencySymbol = Shopify.currency.active;
    let currencyCode = {
        EUR: "€",
        USD: "$",
        GBP: "Â£",
        CAD: "$"
    };
    if (currencyCode.hasOwnProperty(currencySymbol)) {
        currencySymbol = currencyCode[currencySymbol]
    }
    let cart_currency = Shopify.currency.active;

// Check amount and set message


// Shipping Countries
    const otherEuropeanCountries = [
        "al", // Albania
        "ad", // Andorra
        "am", // Armenia
        "az", // Azerbaijan
        "by", // Belarus
        "be", // Belgium
        "ba", // Bosnia and Herzegovina
        "bg", // Bulgaria
        "hr", // Croatia
        "cy", // Cyprus
        "cz", // Czech Republic
        "dk", // Denmark
        "ee", // Estonia
        "fo", // Faroe Islands
        "fi", // Finland
        "fr", // France
        "ge", // Georgia
        "gi", // Gibraltar
        "gr", // Greece
        "gg", // Guernsey
        "va", // Holy See
        "hu", // Hungary
        "is", // Iceland
        "ie", // Ireland
        "im", // Isle of Man
        "it", // Italy
        "je", // Jersey
        "xk", // Kosovo
        "lv", // Latvia
        "li", // Liechtenstein
        "lt", // Lithuania
        "lu", // Luxembourg
        "mt", // Malta
        "md", // Moldova
        "mc", // Monaco
        "me", // Montenegro
        "nl", // Netherlands
        "mk", // North Macedonia
        "no", // Norway
        "pl", // Poland
        "pt", // Portugal
        "ro", // Romania
        "ru", // Russia
        "sm", // San Marino
        "rs", // Serbia
        "sk", // Slovakia
        "si", // Slovenia
        "es", // Spain
        "sj", // Svalbard and Jan Mayen
        "se", // Sweden
        "tr", // Turkey
        "ua", // Ukraine
        "gb" // United Kingdom
    ];
    let shippingBar = '';
    let cartShippingMsg = '';
    let cartShippingStartMsg = '';
    let cartShippingCostMsg = '';
    let cartShippingMsgCost = '';
    if (Shopify.locale == 'en') {
        shippingBar = "Spend [amount] more to get free shipping!";
        cartShippingMsg = "You're eligible for free shipping!";
        cartShippingStartMsg = "Shipping cost from";
        cartShippingCostMsg = "FREE";
        cartShippingMsgCost = "Shipping costs";
    } else if (Shopify.locale == 'fr') {
        shippingBar = "Encore [amount] d'achat pour bénéficier de la livraison gratuite!";
        cartShippingMsg = "Vous bénéficiez de la livraison gratuite !";
        cartShippingStartMsg = "Frais de port à partir de";
        cartShippingCostMsg = "GRATUIT";
        cartShippingMsgCost = "Frais de port";
    } else {
        shippingBar = "Nur noch weitere [amount] für kostenlosen Versand!";
        cartShippingMsg = "Du hast dich für kostenlosen Versand qualifiziert!";
        cartShippingStartMsg = "Versandkosten ab";
        cartShippingCostMsg = "KOSTENLOS";
        cartShippingMsgCost = "Versandkosten";
    }

    let cartShippingMessage = cartShippingStartMsg;
    let cartShippingCost = '';
    let shippingStart = '';
    if (customerCountry == 'de' || customerCountry == 'at') {
        shippingStart = parseInt('4') * parseInt(Shopify.currency.rate);
    } else if (customerCountry == 'ch') {
        shippingStart = parseInt('16') * parseInt(Shopify.currency.rate);
    } else if (customerCountry == 'us') {
        shippingStart = parseInt('17') * parseInt(Shopify.currency.rate);
    } else if (otherEuropeanCountries.includes(customerCountry)) {
        shippingStart = parseInt('9') * parseInt(Shopify.currency.rate);
    } else {
        shippingStart = parseInt('15') * parseInt(Shopify.currency.rate);
    }
    shippingStart = shippingStart * 100;
    cartShippingCost = Shopify.formatMoney(shippingStart, window.theme.moneyFormat);

    axios.get('/cart.js').then(response => {
        let total_price = response.data.total_price;
        let items = response.data.items;
        // Check is there gift card inside cart
        let giftCard = 0;
        items.forEach(item => {
          console.log(item);
          if (item.handle.includes('gift-card')) {
            giftCard = item.price * item.quantity;
          }
        });
        
        if (cart_currency != 'EUR' || cart_currency != 'CHF' || cart_currency != 'USD') {
            treshold = Math.round(treshold * Shopify.currency.rate);
            treshold = Math.ceil(treshold / 100) * 100;
        }
        // total price is = total_price - giftCard
        total_price = total_price - giftCard;
        let differenceSpend = treshold - total_price;
        let amountToSpend = Shopify.formatMoney(differenceSpend, window.theme.moneyFormat);
        let message = shippingBar;
        message = message.replace('[amount]', amountToSpend);
        // If treshold < total_price - shipping is free
        if (total_price >= treshold) {
            message = cartShippingMsg;
            cartShippingCost = cartShippingCostMsg;
            cartShippingMessage = cartShippingMsgCost;
        }
        // If there is just one product and that product is gift card
        let total_items = response.data.items.length;
        let first_item = response.data.items[0];

        let thresholdElement = document.querySelector('.Cart__ShippingNotice');
        if(total_items == 1 && first_item.handle.includes('gift-card')) {
          message = cartShippingMsg;
            cartShippingCost = cartShippingCostMsg;
          thresholdElement.style.display = 'none';
        } else {
            if (thresholdElement && thresholdElement.style) {
                thresholdElement.style.display = 'block';
            }
        }
        const drawerBarMessage = document.getElementById('drawer_bar_message');
        if (drawerBarMessage) {
            drawerBarMessage.innerHTML = message;
        }

        // Set progress bar

        let percentage = parseInt(100 * total_price / treshold);
        let width = 0;
        width = percentage + '%';
        console.log(width);
        const progressLineEl = document.getElementById('progress-line');
        if (percentage < 100) {
            if (progressLineEl && progressLineEl.style) {
                progressLineEl.style.width = width;
            }
        } else {
            progressLineEl.style.width = '100%';
        }

// Shipping message updates

        const shippingCostEl = document.getElementById('shipping-message-costs');
        if (shippingCostEl) {
            shippingCostEl.innerHTML = cartShippingCost;
        }
        const shippingMessageEl = document.getElementById('shipping-message');
        if (shippingMessageEl) {
            shippingMessageEl.innerHTML = cartShippingMessage;
        }

    })
}

document.addEventListener('DOMContentLoaded', Shopify.progressBarShipping);
document.addEventListener('country_detected', Shopify.progressBarShipping);
document.addEventListener('cart:rendered', Shopify.progressBarShipping);